import { apiClient } from 'api'
import { Team } from 'types'

type NewTeam = Omit<Team, 'id'>

export const getTeams = () => apiClient.get<Team[]>('/teams')

export const getTeamById = (teamId: number) => apiClient.get<Team>(`/teams/${teamId}`)

export const createTeam = (team: NewTeam) => apiClient.post<NewTeam, Team>('/teams', team)

export const editTeam = (team: Team) => apiClient.patch<Team>(`/teams/${team.id}`, team)

export const deleteTeam = (id: number) => apiClient.delete(`/teams/${id}`)
